import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { DataService } from '../../data.service';
import * as _ from 'underscore';
import { ListsService } from '../../lists.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Title, Meta } from '@angular/platform-browser';
import { ProductsService } from '../../products.service';

@Component({
  selector: 'app-products-list',
  templateUrl: './products-list.component.html',
  styleUrls: ['./products-list.component.scss']
})
export class ProductsListComponent implements OnInit, OnDestroy {
  destroy$: Subject<boolean> = new Subject<boolean>();

  header = {
    title: 'Produkty',
    text: `Szampony, odżywki, maski, lakiery... W naszej ofercie znajdziesz wszystko,
    co niezbędne do profesjonalnego i skutecznego dbania o włosy.
    Poznaj produkty L’Oréal Professionnel i przekonaj się, jaką
    przyjemność można czerpać z pielęgnacji!`
  };


  collapse = {
    efekty: true,
    produkty: true,
    gamy: true
  };

  currentOpen;

  data = null;

  params = {
    page: 1,
    perPage: 1000,
    sort: 'default_se',
    direction: 'desc'
  };

  total_pages;

  currentType;
  currentCategory;
  type;

  routerSubscribe;
  showFilters;

  breadcrumbs = [];

  catName = {
    produkty: 'Produkty',
    gamy: 'Gamy',
    efekty: 'Efekty'
  };

  filters;

  displayFilters;
  sortOpen = false;
  sorting = 'default_se;desc';

  @HostListener('window:click', ['$event']) onClick(event) {
    if (event.target.classList.contains('show')) {
      this.showFilters = false;
    }
  }

  constructor(
    private dataService: DataService,
    private router: Router,
    private route: ActivatedRoute,
    public _lists: ListsService,
    private _title: Title,
    private _meta: Meta,
    public _products: ProductsService
  ) {}

  filterProducts(category, item) {
    item.checked = !item.checked;

    if (item.checked) {
      this.filters[category].push(item.id);
    } else {
      const filterIndex = this.filters[category].indexOf(item.id);
      this.filters[category].splice(filterIndex, 1);
    }

    this.displayFilters = this._products.getFilters(this.filters);
    this.data = this._products.getProducts(this.filters);
  }

  submitFilters() {
    this.showFilters = false;
    this.data = null;
    this.params.page = 1;
    this.getData();
  }

  setSorting(sort) {
    this.sorting = sort;
    const items = sort.split(';');
    this.params.sort = items[0];
    this.params.direction = items[1];

    this._products.loadData(this.params).then(() => {
      this.displayFilters = this._products.getFilters(this.filters);
      this.data = this._products.getProducts(this.filters);
    });
  }

  setFilters() {
    this.showFilters = false;
  }

  clearMainFilter(category, type) {
    let typ;
    switch (type) {
      case 'gamy':
        typ = 'gama';
        break;
      case 'produkty':
        typ = 'categories';
        break;
      case 'efekty':
        typ = 'effect';
        break;
    }
    const item = _.findWhere(this._lists.data[type], { slug: category });
    const itemIndex = this.filters[typ].indexOf(item.id);
    this.filters[typ].splice(itemIndex, 1);

    this.displayFilters = this._products.getFilters(this.filters);
    this.data = this._products.getProducts(this.filters);
  }

  clearFilters() {
    this.params.sort = 'default_se';
    this.params.direction = 'desc';

    // tslint:disable-next-line: forin
    for (const key in this._products.filters) {
      this._products.filters[key].items.forEach(item => {
        if (item.checked) {
          item.checked = false;
        }
        // console.log(item);
      });

    }

    this.filters = {
      categories: [],
      gama: [],
      type: [],
      effect: []
    };



    if (this.currentCategory) {
      const category = _.findWhere(this._lists.data[this.currentType], { slug: this.currentCategory });
      if (this.currentType === 'gamy') {
        this.filters.gama.push(category.id);
      } else if (this.currentType === 'efekty') {
        this.filters.effect.push(category.id);
      } else {
        this.filters.categories.push(category.id);
      }
    }

    this.data = this._products.getProducts(this.filters);
    this.displayFilters = this._products.getFilters(this.filters);


    // this._products.clearFilters();
    // this._products.loadData(this.params).then(() => {
    //   this.displayFilters = this._products.getFilters(this.filters);
    //   this.data = this._products.getProducts(this.filters);
    //   this.showFilters = false;
    // });
  }

  parseParams(params) {
    const newFilters = {};
    for (const key in params) {
      if (_.isArray(params[key])) {
        params[key].forEach((element, index) => {
          newFilters[`${key}[${index}]`] = element;
        });
      } else {
        newFilters[key] = params[key];
      }
    }
    return newFilters;
  }

  getData() {}

  initData() {
    this.currentCategory = this.route.snapshot.params['category'];
    this.currentType = this.router.url.split('/')[1].split('?')[0];
    this.currentOpen = this.currentType;

    if (this._lists.data && this._lists.data[this.currentType] && this._lists.data[this.currentType].length > 0) {

      this._products.clearFilters();
      if (this.currentCategory) {
        const category = _.findWhere(this._lists.data[this.currentType], { slug: this.currentCategory });
        if (this.currentType === 'gamy') {
          this.filters.gama = [category.id];
          this._title.setTitle(`${category.name} | Gamy | Salon Expert L'Oréal Professionnel`);
          this._meta.updateTag({ property: 'og:title', content: `${category.name} | Gamy | Salon Expert L'Oréal Professionnel` });
        } else if (this.currentType === 'efekty') {
          this.filters.effect = [category.id];
          this._title.setTitle(`${category.name} | Efekty | Salon Expert L'Oréal Professionnel`);
          this._meta.updateTag({ property: 'og:title', content: `${category.name} | Efekty | Salon Expert L'Oréal Professionnel` });
        } else {
          this.filters.categories = [category.id];
          this._title.setTitle(`${category.name} | Produkty | Salon Expert L'Oréal Professionnel`);
          this._meta.updateTag({ property: 'og:title', content: `${category.name} | Produkty | Salon Expert L'Oréal Professionnel` });
        }
      } else {
        if (this.currentType === 'gamy') {
          this._title.setTitle(`Gamy | Salon Expert L'Oréal Professionnel`);
          this._meta.updateTag({ property: 'og:title', content: `Gamy | Salon Expert L'Oréal Professionnel` });
        } else if (this.currentType === 'efekty') {
          this._title.setTitle(`Efekty | Salon Expert L'Oréal Professionnel`);
          this._meta.updateTag({ property: 'og:title', content: `Efekty | Salon Expert L'Oréal Professionnel` });
        } else {
          this._title.setTitle(`Produkty | Salon Expert L'Oréal Professionnel`);
          this._meta.updateTag({ property: 'og:title', content: `Produkty | Salon Expert L'Oréal Professionnel` });
        }
      }

      this._products.loadData(this.params).then(() => {
      
        this.displayFilters = this._products.getFilters(this.filters);
        this.data = this._products.getProducts(this.filters);
      });

    } else {
      setTimeout(() => {
        this.initData();
      }, 500);
    }
  }

  whenScroll() {
    this.params.page++;
    if (this.params.page <= this.total_pages) {
      this.getData();
    }
  }

  ngOnInit() {
    this.filters = this._products.getStartFilters(true);
    this.initData();

    this.router.events.pipe(takeUntil(this.destroy$)).subscribe((event) => {
      if (event instanceof NavigationEnd) {

        this.filters = this._products.getStartFilters();

        if (this.currentType !== this.router.url.split('/')[1]) {
          this.clearFilters();
        } else {
          this.filters = this._products.getStartFilters();
        }

        // this.clearMainFilter(this.currentCategory, this.currentType);
        this.data = null;
        this.initData();
      }
    });
  }

  ngOnDestroy() {
    // Unsubscribe from whatever used takeUntil(destroy$)
    this.destroy$.next(true);
    // Now let's also unsubscribe from the subject itself:
    this.destroy$.unsubscribe();
  }
}
